import { ToastMessageOptions } from 'primeng/api';
import { Injectable, signal } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class PlatformSignalService {
    private _platformSignal = signal<ToastMessageOptions>({});

    public get platformSignal(): ToastMessageOptions {
        return this._platformSignal();
    }

    public set platformSignal(value: ToastMessageOptions) {
        this._platformSignal.set(value);
    }
}
